import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase/index';
import Form from './Form';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { FIELDS } from './validation/fields';
import { schema } from './validation/schema';

const ExtendValidity = ({ ...props }) => {
  const { mobile, motiveId, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        issueForm
        mobile={mobile}
        title=""
        form={
          <Form
            issueForm
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
          />
        }
        data={data}
        fields={FIELDS}
        formName="ExtendValidity"
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        schema={schema}
        motiveId={motiveId}
        typeId={typeId}
      />
    </React.Fragment>
  );
};

ExtendValidity.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
};

export default ExtendValidity;
